import styled from 'styled-components'

export const Image = styled.img`
  margin: 10px;
  max-width: calc(100vw - 40px);
`